import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initalState = {
    recentHisCalls: {},
    error: null,
    loading: false,
};

const callAgentHistoryStart = (state, action) =>{ 
    return updateObject(state, {loading: true});
}

const callAgentHistorySuccess = (state,action) =>{
    return updateObject(state, {
        recentHisCalls: action.recentCalls,
        loading: false,
        error: null,
    })
    
}

const callAgentHistoryFail = (state, action) => {
    return updateObject(state, {error: action.error, loading:false})
}

const reducer = (state = initalState, action) =>{
    switch(action.type){
      case  actionTypes.CALL_AGENT_HISTORY_START:
    return callAgentHistoryStart(state, action);
     case actionTypes.CALL_AGENT_HISTORY_SUCCESS:
        return callAgentHistorySuccess(state,action);
    case actionTypes.CALL_AGENT_HISTORY_FAIL:
          return callAgentHistoryFail(state,action); 
    default :
     return state;
    }
}

export default reducer;